import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientHeadController_SaveStatus_Input_Status,
  useLegalClientBodySaveStatusMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseLegalClientBodyEntity } from 'api/helpers/legal/parseEntity/parseLegalClientBodyEntity';

interface Props {
  versionNumber: number;
  reason: string;
}

export const useLegalClientBodyArchive = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBodySaveStatusMutation();

  const error = useError(apolloError);

  return {
    legalClientBody: data?.saveStatus
      ? parseLegalClientBodyEntity(data.saveStatus)
      : undefined,
    loading,
    error,
    archive: useCallback(
      async (id: string, { reason, versionNumber }: Props) => {
        const res = await handle({
          variables: {
            id,
            input: {
              reason,
              versionNumber,
              status:
                MutationInput_LegalClientHeadController_SaveStatus_Input_Status.Archived,
            },
          },
        });
        return res.data?.saveStatus
          ? parseLegalClientBodyEntity(res.data?.saveStatus)
          : undefined;
      },
      [handle]
    ),
  };
};
